// =====================================================================
// TableView (Quadros PRO / Onda 1 / S60) — visão planilha dos cards.
// =====================================================================
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Chip, Typography } from "@material-ui/core";
import { priorityMeta, fmtDateBR, LINK_KINDS } from "../../services/boardService";

const TableView = ({ board, users, onOpenCard }) => {
  const userName = (id) => { const u = (users || []).find((x) => Number(x.id) === Number(id)); return u ? u.name : ""; };
  const cards = (board.lists || []).flatMap((l) => (l.cards || []).map((c) => ({ ...c, listName: l.name })));

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Título</TableCell>
          <TableCell>Coluna</TableCell>
          <TableCell>Responsável</TableCell>
          <TableCell>Prioridade</TableCell>
          <TableCell>Prazo</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Vínculos</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {cards.map((c) => {
          const pm = priorityMeta(c.priority);
          const linkIcons = LINK_KINDS.filter((k) => c[`${k.kind}Id`]).map((k) => k.icon).join(" ");
          return (
            <TableRow key={c.id} hover style={{ cursor: "pointer" }} onClick={() => onOpenCard(c)}>
              <TableCell style={{ textDecoration: c.done ? "line-through" : "none" }}>{c.title}</TableCell>
              <TableCell>{c.listName}</TableCell>
              <TableCell>{userName(c.assignedUserId)}</TableCell>
              <TableCell>{c.priority ? <Chip size="small" label={pm.label} style={{ background: pm.color, color: "#fff" }} /> : ""}</TableCell>
              <TableCell>{c.dueDate ? fmtDateBR(c.dueDate) : ""}</TableCell>
              <TableCell>{c.done ? "Concluído" : "Aberto"}</TableCell>
              <TableCell>{linkIcons}</TableCell>
            </TableRow>
          );
        })}
        {cards.length === 0 && (
          <TableRow><TableCell colSpan={7}><Typography variant="body2" color="textSecondary">Sem cards.</Typography></TableCell></TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default TableView;
